import { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, } from "../../../utils/const/estilos-const";
import { useTranslation } from "react-i18next";
import spinner from "../../../assets/iconos/spinner4.svg";
import readXlsxFile from "read-excel-file";
import { COLUMNAS_EXCEL, INDEX_COLUMNAS_EXCEL } from "./concepto";
import shortid from "shortid";
import Select from "react-select";
import { procesarCampo } from "../../../utils/shared-functions";
import { actualizarConfiguracionExcelImportarVehiculo, createConfiguracionExcelImportarVehiculo, obtenerConfiguracionExcelImportarVehiculo } from "../../../api/api-configuracion-importar-excel-vehiculo";

export default function SettingsExcelVehiculo() {

    const { t } = useTranslation();
    // const history = useHistory();
    // const [cargandoPage, setCargandoPage] = useState(true);
    const columnasExcel = COLUMNAS_EXCEL;
    // const [importoExcel, setImportoExcel] = useState(false);    
    const [columnasExcelPersonal, setColumnasExcelPersonal] = useState({});
    const [listColumnsExcelImportado, setListColumnsExcelImportado] = useState([]);
    const [comboExcel, setComboExcel] = useState([]);
    const [idConfiguracion, setIdConfiguracion] = useState(0);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        try {
            // if (cargandoPage === false) {
            const fileUpload = document.getElementById("fileUpload");
            fileUpload.addEventListener("change", () => {
                readXlsxFile(fileUpload.files[0]).then((rows) => {
                    // console.log('listener excel');
                    reset();
                    procesarExcel(rows);
                });
            });
            iniciar();
        } catch (e) {
            console.error(e.message);
        }
    }, []);

    const iniciar = async () => {
        try {
            const resp = await obtenerConfiguracionExcelImportarVehiculo();
            // console.log('resp');
            // console.log(resp);
            if (resp.error === false && resp.body != null) {
                const id = resp.body.id;
                setIdConfiguracion(id);
                parseBody(resp.body);
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const parseBody = (body) => {
        try {
            let columnasExcelPersonalPivote = { ...columnasExcelPersonal };
            let comboExcelPivote = [];

            const campos = [
                { index: body.indexCode, valor: body.valorDefaultCode, key: INDEX_COLUMNAS_EXCEL.CODE },
                { index: body.indexLicencePlate, valor: body.valorDefaultLicencePlate, key: INDEX_COLUMNAS_EXCEL.LICENCE_PLATE },
                { index: body.indexLabel, valor: body.valorDefaultLabel, key: INDEX_COLUMNAS_EXCEL.LABEL },
                { index: body.indexTypeVehicle, valor: body.valorDefaultTypeVehicle, key: INDEX_COLUMNAS_EXCEL.TYPE_VEHICLE },
                { index: body.indexBrand, valor: body.valorDefaultBrand, key: INDEX_COLUMNAS_EXCEL.BRAND },
                { index: body.indexModel, valor: body.valorDefaultModel, key: INDEX_COLUMNAS_EXCEL.MODEL },
                { index: body.indexYear, valor: body.valorDefaultYear, key: INDEX_COLUMNAS_EXCEL.YEAR },
                { index: body.indexFuel, valor: body.valorDefaultFuel, key: INDEX_COLUMNAS_EXCEL.FUEL },
            ];

            campos.forEach(({ index, valor, key }) =>
                procesarCampo(index, valor, key, comboExcelPivote, columnasExcelPersonalPivote)
            );

            setComboExcel(comboExcelPivote);
            setListColumnsExcelImportado(comboExcelPivote);
            setColumnasExcelPersonal(columnasExcelPersonalPivote);

        } catch (err) {
            console.log('parseBody err', err);
        }
    };


    const importar = () => {
        try {
            document.getElementById("fileUpload").click();
        } catch (err) {
            console.log("importarExcel err");
            console.log(err);
        }
    };

    const handleAtrasClick = () => {
        // history.goBack();
        window.location.href = "/administer";
    };

    const cardColumnasBase = (data) => {
        try {
            return (
                <div
                    key={shortid.generate()}
                    style={{ marginBottom: 10, }}
                >
                    <div
                        style={{ border: '1px solid black', borderRadius: 5, }}
                    >
                        <div
                            key={shortid.generate()}
                            style={{
                                display: 'flex', justifyContent: 'space-between',
                                padding: 10,
                            }}
                            onClick={() => { }}
                        >
                            <div
                                style={{ color: data.obligatorio === true ? "red" : "black" }}
                            >
                                {data.value + "-" + data.label}
                            </div>
                            {/* <div>
                                {data.verMas == true
                                    ?
                                    <Icon.ChevronUp />
                                    :
                                    <Icon.ChevronDown />
                                }
                            </div> */}
                        </div>
                        {/* {data.verMas == true
                            ?
                            <div
                                style={{ paddingLeft: 10, paddingRight: 10 }}
                            >
                                {data.descripcion}
                            </div>
                            :
                            null
                        } */}
                    </div>
                </div>
            );
        } catch (err) {
            console.log('cardColumnasBase err');
            console.log(err);
            return (
                <div></div>
            );
        }
    };

    const cardColumnasExcelPersonal = (index) => {
        try {
            return (
                <div
                    key={shortid.generate()}
                    style={{ marginBottom: 9.3, }}
                >
                    <div
                        style={{ border: '1px solid rgb(17, 58, 95)', borderRadius: 5, }}
                    >
                        <div
                            key={shortid.generate()}
                            style={{
                                padding: 3.5,
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <div
                                style={{
                                    width: '50%'
                                }}
                            >
                                <Select
                                    placeholder="Seleccione columna..."
                                    options={comboExcel}
                                    autosize={false}
                                    key={shortid.generate()}
                                    isClearable={true}
                                    value={obtenerValorCombo(index)}
                                    onChange={(v) => {
                                        actualizarCombo(v, index);
                                    }}
                                />
                            </div>
                            {/* <div
                                style={{
                                    width: '60%',
                                    paddingLeft: 10,
                                }}
                            >
                                <Input type="text" value={this.obtenerValorEjemplo(index)} readOnly
                                    style={{ width: 'auto', height: '35px' }}
                                />
                            </div> */}
                        </div>
                    </div>
                </div>
            );
        } catch (err) {
            console.log('cardColumnasBase err');
            console.log(err);
            return (
                <div></div>
            );
        }
    };

    const actualizarCombo = (value, index) => {
        try {
            // console.log('actualizarCombo');
            // console.log(value);
            // console.log(index);
            // return;
            // let columnasExcelPersonal = this.state.columnasExcelPersonal;
            // console.log('checkRepetirColumnasExcel');
            // console.log(this.state.checkRepetirColumnasExcel);
            let comboExcelPivote = [...comboExcel];
            let columnasExcelPersonalPivote = { ...columnasExcelPersonal };
            if (value !== null) {
                columnasExcelPersonalPivote[`${index}`] = {};
                columnasExcelPersonalPivote[`${index}`].valorCombo = value;
                comboExcelPivote = comboExcelPivote.filter(e => e.value !== value.value);
                // Remove duplicates
                comboExcelPivote = comboExcelPivote.filter(
                    (item, idx, self) =>
                        idx === self.findIndex((t) => t.value === item.value)
                );
                setComboExcel(comboExcelPivote);
                setColumnasExcelPersonal(columnasExcelPersonalPivote);
            }
            if (value === null) {
                const valorRecuperado = listColumnsExcelImportado[`${index}`];
                comboExcelPivote.push(valorRecuperado);
                comboExcelPivote.sort((a, b) => a.value - b.value);
                columnasExcelPersonalPivote[`${index}`] = null;
                comboExcelPivote = comboExcelPivote.filter(
                    (item, idx, self) =>
                        idx === self.findIndex((t) => t.value === item.value)
                );
                setComboExcel(comboExcelPivote);
                setColumnasExcelPersonal(columnasExcelPersonalPivote);
            }
        } catch (err) {
            console.log('actualizarCombo err');
            console.log(err);
        }
    };

    const obtenerValorCombo = (index) => {
        try {
            // console.log('obtenerValorCombo');
            // console.log('columnasExcelPersonal', columnasExcelPersonal);
            // let columnasExcelPersonal = this.state.columnasExcelPersonal;
            if (columnasExcelPersonal === undefined || columnasExcelPersonal === null) {
                return null;
            }
            const obj = columnasExcelPersonal[`${index}`];
            // console.log('obj', obj);
            if (obj !== undefined && obj !== null) {
                return obj.valorCombo;
            }
            return null;
        } catch (err) {
            console.log('obtenerValorCombo err');
            console.log(err);
            return null;
        }
    };

    const reset = () => {
        try {
            // console.log('reset');
            setColumnasExcelPersonal();
            setComboExcel([]);
            // setImportoExcel(false);
            setListColumnsExcelImportado([]);
        } catch (err) {
            console.log('reset err');
            console.log(err);
        }
    };

    const procesarExcel = (rows) => {
        try {
            // console.log('procesarExcel');
            if (rows.length === 0) {
                return;
            }
            // console.log('rows');
            // console.log(rows);
            let comboExcel = [];
            let headers = rows[0];
            for (let index = 0; index < headers.length; index++) {
                const element = headers[index];
                let objColumna = {};
                objColumna.value = index;
                objColumna.label = index + " - " + element;
                comboExcel.push(objColumna);
            }
            comboExcel.sort((a, b) => a.value - b.value);
            // console.log("comboExcel", comboExcel);
            setListColumnsExcelImportado(comboExcel);
            setComboExcel(comboExcel);
        } catch (error) {
            console.log('procesarExcel err');
            console.log(error);
        }
    };

    const guardarConfiguracion = async () => {
        try {
            setLoading(true);
            let objEnviar = {};

            objEnviar.id = idConfiguracion;

            objEnviar.indexCode = -1;
            objEnviar.valorDefaultCode = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.CODE}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.CODE}`] !== null) {
                objEnviar.indexCode = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.CODE}`].valorCombo.value;
                objEnviar.valorDefaultCode = {};
                objEnviar.valorDefaultCode.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.CODE}`].valorCombo.value;
                objEnviar.valorDefaultCode.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.CODE}`].valorCombo.label;
            }

            objEnviar.indexLicencePlate = -1;
            objEnviar.valorDefaultLicencePlate = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LICENCE_PLATE}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LICENCE_PLATE}`] !== null) {
                objEnviar.indexLicencePlate = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LICENCE_PLATE}`].valorCombo.value;
                objEnviar.valorDefaultLicencePlate = {};
                objEnviar.valorDefaultLicencePlate.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LICENCE_PLATE}`].valorCombo.value;
                objEnviar.valorDefaultLicencePlate.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LICENCE_PLATE}`].valorCombo.label;
            }

            objEnviar.indexLabel = -1;
            objEnviar.valorDefaultLabel = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LABEL}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LABEL}`] !== null) {
                objEnviar.indexLabel = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LABEL}`].valorCombo.value;
                objEnviar.valorDefaultLabel = {};
                objEnviar.valorDefaultLabel.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LABEL}`].valorCombo.value;
                objEnviar.valorDefaultLabel.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.LABEL}`].valorCombo.label;
            }

            objEnviar.indexTypeVehicle = -1;
            objEnviar.valorDefaultTypeVehicle = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.TYPE_VEHICLE}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.TYPE_VEHICLE}`] !== null) {
                objEnviar.indexTypeVehicle = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.TYPE_VEHICLE}`].valorCombo.value;
                objEnviar.valorDefaultTypeVehicle = {};
                objEnviar.valorDefaultTypeVehicle.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.TYPE_VEHICLE}`].valorCombo.value;
                objEnviar.valorDefaultTypeVehicle.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.TYPE_VEHICLE}`].valorCombo.label;
            }

            objEnviar.indexBrand = -1;
            objEnviar.valorDefaultBrand = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.BRAND}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.BRAND}`] !== null) {
                objEnviar.indexBrand = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.BRAND}`].valorCombo.value;
                objEnviar.valorDefaultBrand = {};
                objEnviar.valorDefaultBrand.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.BRAND}`].valorCombo.value;
                objEnviar.valorDefaultBrand.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.BRAND}`].valorCombo.label;
            }

            objEnviar.indexModel = -1;
            objEnviar.valorDefaultModel = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.MODEL}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.MODEL}`] !== null) {
                objEnviar.indexModel = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.MODEL}`].valorCombo.value;
                objEnviar.valorDefaultModel = {};
                objEnviar.valorDefaultModel.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.MODEL}`].valorCombo.value;
                objEnviar.valorDefaultModel.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.MODEL}`].valorCombo.label;
            }

            objEnviar.indexYear = -1;
            objEnviar.valorDefaultYear = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.YEAR}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.YEAR}`] !== null) {
                objEnviar.indexYear = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.YEAR}`].valorCombo.value;
                objEnviar.valorDefaultYear = {};
                objEnviar.valorDefaultYear.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.YEAR}`].valorCombo.value;
                objEnviar.valorDefaultYear.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.YEAR}`].valorCombo.label;
            }

            objEnviar.indexFuel = -1;
            objEnviar.valorDefaultFuel = null;
            if (columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.FUEL}`] !== undefined && columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.FUEL}`] !== null) {
                objEnviar.indexFuel = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.FUEL}`].valorCombo.value;
                objEnviar.valorDefaultFuel = {};
                objEnviar.valorDefaultFuel.value = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.FUEL}`].valorCombo.value;
                objEnviar.valorDefaultFuel.label = columnasExcelPersonal[`${INDEX_COLUMNAS_EXCEL.FUEL}`].valorCombo.label;
            }

            if (idConfiguracion === 0) {
                const resp = await createConfiguracionExcelImportarVehiculo(objEnviar);
                if (resp.error === false) {
                    alert(t("alert_successfully_proccess"));
                    handleAtrasClick();
                } else {
                    alert(t("alert_could_not_process"));
                }
            }

            if (idConfiguracion !== 0) {
                const resp = await actualizarConfiguracionExcelImportarVehiculo(objEnviar);
                if (resp.error === false) {
                    alert(t("alert_successfully_proccess"));
                    handleAtrasClick();
                } else {
                    alert(t("alert_could_not_process"));
                }
            }

            setLoading(false);
        } catch (err) {
            console.log('guardarConfiguracion err');
            console.log(err);
            setLoading(false);
        }
    };

    const render = () => {
        try {
            // if (cargandoPage === true) {
            //     return cargandoCard();
            // }
            return (
                <div className="p-4">
                    <div className="flex justify-between">
                        <label
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            {t("title_manage_config_excel")}
                        </label>
                        <div className="flex justify-center">

                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={(handleAtrasClick)}
                            >
                                {t("label_back")}
                            </button>
                        </div>
                    </div>
                    <br />
                    <div className="flex justify-end">
                        <button
                            className="bg-[#84B044] rounded text-white p-2"
                            onClick={() => {
                                importar();
                            }}
                        >
                            IMPORTAR
                        </button>
                        <input
                            id="fileUpload"
                            type="file"
                            className="my-auto text-white p-[5px] px-[10px] mr-[10px] hidden"
                            accept=".xlsx,.xls"
                        />
                    </div>
                    <br />
                    <hr />
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            {columnasExcel.map((data) => {
                                return cardColumnasBase(data);
                            })}
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-8 xl:col-span-8">
                            {listColumnsExcelImportado.map((_, index) => {
                                return cardColumnasExcelPersonal(index);
                            })}
                        </div>
                    </div>
                    <br />
                    <div className="flex justify-end">
                        {loading === false && (
                            <button
                                onClick={guardarConfiguracion}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                GUARDAR
                            </button>
                        )}
                        {loading === true && (
                            <button className="login_button flex justify-center">
                                <img className="spinner"
                                    alt="spinner" src={spinner} />
                            </button>
                        )}
                    </div>
                </div>
            );
        } catch (err) {
            console.log('SettingsExcelEquipo render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    };

    return render();
}